import {
  DetailSectionItem,
  DetailSection as DetailSectionType,
} from '@sr/types';
import DateRange from '../common/DateRange';
import Divider from '../common/Divider';
import Summary from '../common/Summary';
import { Box, SectionHeading, SectionItemHeading, Text } from '../common/ui';
import { detailItemsFromSection } from '../common/utils';

const DetailSection = ({
  section,
  currentDateString,
}: {
  section: DetailSectionType;
  currentDateString?: string | null;
}) => {
  const items = detailItemsFromSection(section);
  return (
    <Box variant="sectionContainer" as="section">
      <SectionHeading>{section.title}</SectionHeading>
      {items.map((item: DetailSectionItem) => {
        return (
          <Box
            variant="detailSectionItemContainer"
            key={item.id}
            sx={{
              pageBreakInside: 'avoid',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: ['column', 'row'],
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                }}
              >
                <Divider divider=", ">
                  {item.title && (
                    <SectionItemHeading url={item.website}>
                      {item.title}
                    </SectionItemHeading>
                  )}
                  {item.subtitle && (
                    <Text variant="sectionItemSubHeading" pl={3}>
                      {item.subtitle}
                    </Text>
                  )}
                </Divider>
              </Box>
              <Text
                sx={{
                  variant: 'text.sectionItemSubHeading',
                  color: 'tertiaryText',
                  flexShrink: 0,
                }}
              >
                <DateRange
                  startDate={item.startDate}
                  stopDate={item.stopDate}
                  isCurrent={item.isCurrent}
                  currentDateString={currentDateString}
                />
              </Text>
            </Box>
            <Summary summary={item.summary} textType={item.textType} />
          </Box>
        );
      })}
    </Box>
  );
};

export default DetailSection;
